import React, {useState} from 'react'
import { useProjects } from 'context/project-context'
import useAxios from 'axios-hooks'
import { getAuthHeader } from 'utils/auth'
import ScanCompareTop from 'views/ScanSettings/ScanCompare/components/ScanCompareTop'
import { StringParam, useQueryParams, ObjectParam } from 'use-query-params'
import ScanView from 'views/ScanSettings/components/ScanView'
import ScanCompareWidgets from 'views/ScanSettings/ScanCompare/components/ScanCompareWidgets'
import { Icon, Popover } from 'antd'
import { MiniCounters } from 'views/ScanSettings/ScanCompare/components/ScanCompareStatCounters'
import styled from '@emotion/styled'
import { colors } from 'style/theme'
import { ErrorBoundary } from 'components'

const CountersIcon = styled(Icon)({
	fontSize: 24,
	color: colors.brand
})

const customColumns = [
	{
		position: 5,
		dataIndex: 'counters',
		align: 'center',
		width: 50,
		render(record) {
			return (
				<Popover content={<MiniCounters data={record} />}>
					<CountersIcon type="history" />
				</Popover>
			)
		}
	}
]

function ScanCompare({ scanSettingsId, scanA, scanB }) {
	const { project } = useProjects()
	const [exportFilters, setFiltersForExport] = useState([])
	const [exportError, setExportError] = useState(null)

	const [detailsView, setDetailsView] = useQueryParams({
		details: StringParam,
		"document_a_id": StringParam,
		"document_b_id": StringParam,
	})

	const [
		{ data: scanCompareData, loading: loadingScanCompareData, error: scanCompareDataError },
		fetchScanCompareData
	] = useAxios(
		{
			method: 'POST',
			url: `${project.name}/scan-settings/scan-compare`,
			headers: getAuthHeader()
		},
		{ manual: true }
	)

	const [{ data: detailsData, loading: loadingDetailsData, error: detailsError }, fetchScanDetails] = useAxios(
		{
			method: 'POST',
			url: `${project.name}/scan-settings/document-compare`,
			headers: getAuthHeader()
		},
		{ manual: true }
	)

	let isDetailsView = !!detailsView.document_a_id && !!detailsView.document_b_id
	let scanViewData = scanCompareData || {}
	let loadingData = loadingScanCompareData || loadingDetailsData
	let fetchError = scanCompareDataError || detailsError || exportError
	if (isDetailsView && detailsData) {
		scanViewData = detailsData
	}
	let scanSettingsName = scanViewData && scanViewData["scan_settings_name"];

	return (
		<ErrorBoundary>
			<ScanCompareTop
				scanSettingsName={scanSettingsName}
				scanA={scanA}
				scanB={scanB}
				isDetailsView={isDetailsView}
				details={detailsView}
				setDetailsView={setDetailsView}
				scanSettingsId={scanSettingsId}
				exportFilters={exportFilters}
				onExportError={setExportError}
			/>
			<ScanView
				scanViewData={scanViewData}
				customColumns={{ master: customColumns }}
				scanStatus={scanViewData.status}
				fetchData={fetchScanCompareData}
				fetchDetails={fetchScanDetails}
				loadingData={loadingData}
				fetchError={fetchError}
				widgets={ScanCompareWidgets}
				widgetsGrid="2fr repeat(4, 1fr)"
				isDetailsView={isDetailsView}
				setDetailsView={setDetailsView}
				scanSettingsId={scanSettingsId}
				isScanCompare={true}
				compareData={{scanA, scanB}}
				details={detailsView}
				onFiltersChange={setFiltersForExport}
				scanIds={{scanA, scanB, scanSettingsId}}
			/>
		</ErrorBoundary>
	)
}

export default ScanCompare
